import React from 'react';

export interface LunaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const LunaIcon: React.FC<LunaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.406a9 9 0 1 1-9.79-9.79 7 7 0 0 0 9.79 9.79"/>
    </svg>
  );
};

export default LunaIcon;
